<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="专区首页" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <!-- 底部活动区 开始 -->
    <div class="food-block">

      <div class="food-header van-hairline--bottom">
        <img :src="liquan" alt="">

        <span @click="goBirthCompanyProduct(1)">更多 》 </span>
      </div>

      <div class="food-left ">
        <img-text-row :product="itGooda" :type="1" :company_id="company_id" v-for="(itGooda, inGooda) in voucherGoods" :key="inGooda"></img-text-row>
      </div>

    </div>
    <!-- 底部活动区 开始 -->
    <div class="food-block">

      <div class="food-header van-hairline--bottom">
        <img :src="jifen" alt="">
        <span @click="goBirthCompanyProduct(2)">更多 》 </span>
      </div>

      <div class="food-left ">
        <img-text-row :product="itGoods" :type="2" :company_id="company_id" v-for="(itGoods, inGoods) in pointsGoods" :key="inGoods"></img-text-row>
      </div>

    </div>

    <!-- 吸顶tabs -->
    <van-sticky :offset-top="0" :z-index="4002">
      <div class="table-block">
        <!-- 筛选tabs -->
        <div class="l-table">
          <div :class="['tbs-item', tabInd == index ? 'tbs-item-active' : '']" v-for="(item, index) in tabsList" :key="index" @click="onTabs(index)">
            {{ item }}
          </div>
        </div>
        <div class="r-btn" @click="onShowType">
          <img v-if="showType == 'column'" src="../../assets/public/row_icon.png" alt="" />
          <img v-else src="../../assets/public/column_icon.png" alt="" />
        </div>
      </div>
    </van-sticky>

    <!-- 列表 -->
    <div class="list">
      <van-list style="display: flex; flex-wrap:wrap;" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getProductList">
        <img-text-row :show-type="showType" :type="type" :company_id="company_id" :product="item" v-for="(item, index) in productList" :key="index"></img-text-row>
      </van-list>

      <!-- <van-empty class="custom-image" v-if="productList.length< 1" :image="kongUrl" /> -->
    </div>

  </div>
</template>
    
    <script>
import imgTextRow from "@/components/img-text-birth-block/img-text-birth-block.vue";

export default {
  name: "ProductList",
  components: { imgTextRow },
  props: {},
  data() {
    return {
      company_id: this.$route.query.company_id || "",
      // xinpin: require("../../assets/birth-product/title_4.jpg"),
      // hotGoods: [],

      liquan: require("../../assets/birth-product/title_3.jpg"),
      voucherGoods: [],

      jifen: require("../../assets/birth-product/title_1.jpg"),
      pointsGoods: [],

      // kongUrl: require("../../assets/public/kong.png"),
      isFirstEnter: false, // 是否第一次进入，默认false

      showType: "column",
      tabsList: ["礼券", "积分"],
      tabInd: 0,
      isMoney: false,

      productList: [], //商品
      type: 1,
      pageNum: 1,
      pageSize: 20,
      loading: true,
      finished: false,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getList();
    this.getProductList();
  },
  methods: {
    getList() {
      let _this = this;

      this.$toast.loading();
      let data = {
        company_id: this.company_id,
      };

      this.$post("/api/birth_index", data, data).then((res) => {
        console.log(res.data.data);

        if (res.data.code == 0) {
          _this.$toast.clear();
          _this.hotGoods = res.data.data.hotGoods;
          _this.voucherGoods = res.data.data.voucherGoods;
          _this.pointsGoods = res.data.data.pointsGoods;
        } else {
          this.$toast.fail(res.data.message);
          this.$router.go(-1);
        }
      });
    },
    goBirthCompanyProduct(even) {
      let _this = this;
      this.$router.push({
        name: "birth-company-product",
        query: {
          type: even,
          company_id: _this.company_id,
        },
      });
    },
    getProductList() {
      let _this = this;
      let data = {
        company_id: _this.company_id,
        type: _this.type,
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/birth_goods_list", data, data).then((res) => {
        console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            // console.log('444')
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          // console.log('555')
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 点击标签
    goSearchInput(e) {
      this.productList = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getProductList();
    },
    // 切换tabs
    onTabs(ind) {
      this.tabInd = ind;
      if (ind == 0) {
        this.type = 1;
        this.productList = [];
        this.pageNum = 1;
        this.loading = true;
        this.finished = false;
        this.getProductList();
      } else if (ind == 1) {
        this.type = 2;
        this.productList = [];
        this.pageNum = 1;
        this.loading = true;
        this.finished = false;
        this.getProductList();
      }
    },
    // 列表显示种类
    onShowType() {
      this.showType = this.showType == "column" ? "row" : "column";
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goGoodsDetails() {
      this.$toast.fail("敬请期待！");
    },
  },
};
</script>
<style lang="scss">
.search-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 130px;
    height: 150px;
  }

  .van-list__loading {
    width: 100%;
  }
}
</style>
    <style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
  padding: 50px 0;

  .top-bg {
    width: 100%;
    padding: 10px 20px;
    background-color: #fff;
    margin-bottom: 10px;
    img {
      display: block;
      width: 100%;
      height: 160px;
      box-shadow: 0 0 8px rgb(0 0 0 / 30%);
      border-radius: 5px;
    }
    p {
      line-height: 30px;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      color: #272530;
    }
  }
}

.food-block {
  width: 100%;
  // height: 300px;
  background-color: #fff;
  margin-bottom: 20px;

  // 顶部图片
  .food-header {
    // height: 30px;
    width: 100%;
    padding: 10px 0;
    position: relative;
    // border-bottom: 1px solid #f2f2f2;
    // background-color: saddlebrown;
    img {
      width: 128px;
      display: block;
      margin: 0 auto;
    }
    span {
      position: absolute;
      right: 20px;
      top: 14px;
      display: inline-block;

      align-items: center;
      font-size: 12px;
      color: #9c9c9c;
    }
  }

  //左侧
  .food-left {
    padding: 5px 0 0;
    // width: 50%;
    // height: 300px;
    // background-color: forestgreen;
    overflow: hidden;

    .food-left-one {
      float: left;
      width: 50%;
      // margin: 0 5px;
      padding: 10px;
      .food-left-one-title {
        text-align: left;
        font-size: 14px;
        line-height: 18px;
        color: #383838;
        margin-bottom: 5px;
      }
      .food-left-one-subtitle {
        text-align: left;
        font-size: 12px;
        line-height: 18px;
        color: #9c9c9c;
        margin-bottom: 10px;
      }
      .food-left-one-img {
        height: 68px;
        width: 100%;
        display: flex;
        justify-content: end;
        align-items: center;
        img {
          height: 100%;
          display: block;
          // margin: 0 auto;
        }
      }
    }
  }
}
.table-block {
  width: 100%;
  height: 44px;
  z-index: 2002;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.08);

  .l-table {
    flex: 1;
    // width:325px;
    height: 100%;
    color: #78849e;
    font-size: 16px;
    overflow: hidden;
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .tbs-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 18px;

      .tabs-arrow {
        width: 13px;
        height: 13px;
        margin-left: 5px;

        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
      }
      .arrow-u-d {
        background-image: url("../../assets/public/arrow-u-d.png");
      }
      .arrow-up {
        background-image: url("../../assets/public/arrow-up.png");
      }
      .arrow-down {
        background-image: url("../../assets/public/arrow-down.png");
      }
    }
    .tbs-item-active {
      color: #ff5000;
    }
  }
  .r-btn {
    border-left: 1px solid #cccccc;
    width: 50px;
    height: 25px;
    margin-left: 10px;
    // background-color: palegreen;
    img {
      display: block;
      width: 20px;
      height: 20px;
      margin: 2.5px auto;
    }
  }
}

.list {
  // width: 100%;
  // height: 100%;
  padding: 5px 0 0;
  box-sizing: border-box;
  // overflow: hidden;
}
</style>
    